import { render, staticRenderFns } from "./WithdrawPending.vue?vue&type=template&id=89bfc584&scoped=true&"
import script from "./WithdrawPending.vue?vue&type=script&lang=js&"
export * from "./WithdrawPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bfc584",
  null
  
)

export default component.exports